"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.list.title': 'Sessioni di Onboarding',
    'onboarding.list.empty': 'Nessuna sessione di onboarding trovata',
    'onboarding.list.description': 'Gestisci i processi di onboarding per i membri del tuo team.',
    'onboarding.list.records': 'Record di Onboarding',
};
